import moment from 'moment';

export const getExpirationStatus = (expiryDate) => {
  const now = moment();
  const expiry = moment.utc(expiryDate);
  const diffMinutes = expiry.diff(now, 'minutes');

  if (diffMinutes <= 0) {
    return {
      className: 'text-danger',
      messageId: 'booking.expirereserve',
      isExpired: true,
    };
  }

  if (diffMinutes <= 5) {
    return {
      className: 'text-warning',
      messageId: 'booking.tickettimelimit',
      isExpired: false,
    };
  }

  return {
    className: 'text-third',
    messageId: 'booking.tickettimelimit',
    isExpired: false,
  };
};
